export default function arrow() {
  $('.menu-526').on('click', function(e) {
    $(this).toggleClass('active');
  })

  $('select').focusout(function(){
    $(this).parent().removeClass('active');
});
}


// WEBPACK FOOTER //
// ./scripts/modules/arrow.js